export default __webpack_public_path__ + "static/media/accessories-3.d2f32ca1.jfif";